import { Stack } from '@chakra-ui/react';
import React from 'react';
import { UI } from 'src/apps/invest/common/shells/UI';
import { TextBlock } from '../../common/components/TextBlock';
import { AlertList } from './alerts/AlertList';
import { HelpCard } from './help/HelpCard';
import { MessagesList } from './messages/MessagesList';

export const InboxView: React.FC = () => {
  return (
    <UI>
      <TextBlock weight="bold" mb={'24px'} fontSize="40px">
        Inbox
      </TextBlock>
      <Stack gap="30px">
        <AlertList />
        <MessagesList />
        <HelpCard />
      </Stack>
    </UI>
  );
};
